/* global document */

export const NIAS_NAV_BAR_ADD_CONTRAST_ID = 'nonimpaired';
export const NIAS_NAV_BAR_REMOVE_CONTRAST_ID = 'impaired';
export const NIAS_NAV_BAR_REMOVE_DYSLEXIA_ID = 'dyslexic';
export const NIAS_NAV_BAR_ADD_DYSLEXIA_ID = 'nondyslexic';
export const NIAS_NAV_BAR_SMALLER_FONT_ID = 'smaller';
export const NIAS_NAV_BAR_DEFAULT_FONT_ID = 'default';
export const NIAS_NAV_BAR_LARGER_FONT_ID = 'larger';

export const NIAS_NAV_BAR_LOG_BUTTON = 'log_button';
export const NIAS_NAV_BAR_LOGGED_IN_USER_INFO_PART = 'user_logged';

export const NIAS_NAVBAR_CHANGE_ENTITY_BUTTON = 'egradani_user_promjena_subjekta';
